export enum RespondentRoutes {
  RESPONDENT_ID = ':respondentId',
  PROJECT_ID = 'project/:projectId',
  GETTING_STARTED = 'getting-started',
  PAGE = 'page/:pageId',
  REVIEW_SIGN = 'review-sign',
}
